// @flow
import React from 'react';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';

import { SCard } from 'common/modules/printing/styles/Card';
import IntervalGraph from 'common/components/charts/IntervalGraph';
import Radio from 'common/domain/radio';

import ListeningTimeDateRangeMetrics from '../components/ListeningTimeDateRangeMetrics';
import { GraphWrapper } from '../components/styles';
import { convertSeconds } from '../domain/TimeResolution';
import MetricsPrintingHeader from './MetricsPrintingHeader';
import MetricsPrintingParametersCard from './MetricsPrintingParametersCard';
import { MetricsQuery } from '../domain/Metrics';
import type { TimeResolution } from '../domain/TimeResolution';

type Props = {
  listeningTime: MetricsQuery & {
    timeResolution: TimeResolution,
    totalListeningTime: Object,
    listeningTimeByInterval: Object,
    listeningTimePerPerson: Object,
  };

  radio: Radio;

  theme: any;
  t: any;
}

const ContentWrapper = styled.div`
  padding: 3px;
  background-color: white;
  box-sizing: border-box;

  width: 8.5in;
  height: 11in;
  font-size: 12px;

  @page {
    size: letter portrait;
    margin: 2.00cm 0 2.00cm 0;
  }
`;

const TimeResolutionWrapper = styled.div`
  color: ${({ theme }) => theme.colors.secondaryText};
  font-size: 18px;
  margin-top: ${({ theme }) => theme.metrics.margin}px;
  margin-right: ${({ theme }) => theme.metrics.largeMargin}px;
  position: absolute;
  top -35px;
  right: 0;
  z-index: 100;
`;

const ListeningTimePrinting = (props: Props) => {
  const {
    dateRange,
    dateRangeCompared,
    days,
    interval,
    listeningTimeByInterval,
    totalListeningTime,
    listeningTimePerPerson,
    timeResolution,
    centralMarket,
  } = props.listeningTime;
  const { t, radio } = props;

  return (
    <ContentWrapper>
      <MetricsPrintingHeader title={t('listeningTime').toUpperCase()} radio={radio} centralMarket={centralMarket} />
      <MetricsPrintingParametersCard dateRange={dateRange} dateRangeCompared={dateRangeCompared} interval={interval}
        days={days}
      />
      <SCard>
        <ListeningTimeDateRangeMetrics
          smaller
          dateRange={dateRange}
          totalListeningTime={totalListeningTime.data}
          perPerson={listeningTimePerPerson.data}
          timeResolution={timeResolution}
        />
      </SCard>
      {dateRangeCompared &&
      <SCard>
        <ListeningTimeDateRangeMetrics
          smaller
          dateRange={dateRangeCompared}
          totalListeningTime={totalListeningTime.data.compared}
          perPerson={listeningTimePerPerson.data.compared}
          timeResolution={timeResolution}
        />
      </SCard>
      }
      <SCard>
        <GraphWrapper>
          <TimeResolutionWrapper>{t(timeResolution.toLowerCase())}</TimeResolutionWrapper>
          <IntervalGraph
            metricName={t('listeningTime')}
            data={listeningTimeByInterval.data || {}}
            isCompared={Boolean(dateRangeCompared)}
            fromTime={interval.from}
            toTime={interval.to}
            disableAnimations
            displayHorizontalLines
            converter={n => convertSeconds(n, timeResolution)}
            hideBrush
          />
        </GraphWrapper>
      </SCard>
    </ContentWrapper>
  );
};

export default translate('metrics')(withTheme(ListeningTimePrinting));



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/printing/ListeningTimePrinting.js